<template>

</template>

<script>
export default {
  created() {
    this.JudgeEquipment();
  },
  methods: {
    JudgeEquipment() {
      console.log("进来了");
      let authority = JSON.parse(localStorage.getItem("authority"));
      if (window.localStorage.getItem("sid")) {
        return this.$router.push(`/home/${authority[0]}`);
      }
      this.$router.push("/login");
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/login.vue